module.exports = __webpack_public_path__ + "img/hotel2_3.d9be7edf.png";